import { registeredTableHandlers } from '@/global/components/view-layouts/tabs-layout/config/registered-table-handlers'
import { api } from '@/global/services/api'

export default {
  methods: {
    showEdit (event) {
      const { data } = event || {}
      this.$set(this.manageOccupationDialogConfig, 'title', this.$t('people/person-occupation.edit_occupation') + (data?.description ? ' - ' + data.description : ''))
      this.$set(this.manageOccupationDialogConfig, 'createMode', false)
      this.$set(this.manageOccupationDialogConfig, 'editData', data)
      this.$set(this.manageOccupationDialogConfig, 'show', true)
    },

    onOccupationDelete (event) {
      const { id, description } = event?.data || {}
      if (!id) {
        return
      }

      const title = this.$t('people/person-occupation.delete')
      this.$set(this.informationDialogConfig, 'title', title + ' - ' + (description || '/'))
      this.$set(this.informationDialogConfig, 'positiveBtnText', this.$t('base.save'))
      this.$set(this.informationDialogConfig, 'message', this.$t('people/person-occupation.confirm_delete'))
      this.$set(this.informationDialogConfig, 'callbackFn', () => this.occupationDelete(event))
      this.$set(this.informationDialogConfig, 'openDialog', true)
    },

    async occupationDelete (event) {
      try {
        const { id } = event?.data || {}
        const { fetchData } = registeredTableHandlers?.peopleOccupations || {}

        await api('people').delete(`person-occupations/${id}`)

        this.$set(this.informationDialogConfig, 'openDialog', false)
        if (typeof fetchData === 'function') {
          fetchData()
        }
      }
      catch (exception) {
        console.error(exception)
      }
    }
  }
}
